export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverChat_ConnectionLost_Message": "Vent mens vi prøver å koble til på nytt, eller prøv å laste inn siden på nytt.",
	"CaregiverChat_MessageList_NewMessagePlaceholder": "Skrive melding",
	"CaregiverChat_MessageList_SendButton": "Sende",
	"CaregiverChat_MessageList_Title": "Prate",
	"CaregiverChat_OnDutyList_NoCaregiversLabel": "Det er ingen terapeuter på vakt i dag",
	"CaregiverChat_OnDutyList_Title": "Terapeuter på vakt i dag",
	"CprRequired": "HLR må være fullført",
	"Close": "Luk",
	"FieldRequired": "Vennligst fyll ut feltet",
	"EmailRequired": "E-post må fylles ut",
	"PhoneNumberRequired": "Vennligst oppgi telefonnummeret ditt. Da kan vi ta kontakt med deg hvis teknologien er et problem.",
	"ErrorOccured": "Det oppstod en feil. Prøv på nytt eller kontakt oss hvis problemet vedvarer.",
	"ErrorRate": "Det oppstod en feil. Kunne ikke lagre vurderingen. Prøv på nytt eller kontakt oss hvis problemet vedvarer.",
	"InvalidCpr": "Ugyldig CPR-nummer",
	"CprTooShort": "CPR nummeret er for kort. Det skal være 10 cifre på formen: DDMMYYXXXX",
	"CprTooLong": "CPR nummeret er for langt. Det skal være 10 cifre på formen: DDMMYYXXXX",
	"CprTooOld": "Beklager, denne funksjonaliteten er kun for barn under 18 år. Voksne må logge inn med egen MitID for å bestille konsultasjon.",
	"CprTooYoung": "Beklager, denne funksjonaliteten er kun for voksne over 18 år. Barn må være registrert under menyen \"Barn under 18 år\" på profilsiden.",
	"InvalidName": "Det ser ikke ut som et fullt navn. Prøv igjen.",
	"InvalidEmail": "E-mailen er ugyldig.",
	"RequirePaymentText": "Jeg er klar over at denne konsultasjonen krever betaling",
	"ThankYouForRating": "Takk for tilbakemeldingen",
	"EmailAlreadyExist": "Emailen eksisterer allerede i systemet",
	"ErrorCompanyData": "Det oppstod en feil under henting av firmadata",
	"CompanyNameRequired": "Firmanavn påkrevd",
	"ErrorCompany": "Det oppstod en feil under opprettelsen av selskapet",
	"DeleteCompanyDescription": "Når du sletter firmaet \"{companyName}\" vil du miste alle dataene.",
	"DeleteCompanyTitle": "Slett selskap",
	"ErrorDeletingCompany": "Det oppstod en feil under sletting av selskapet",
	"DeleteCompanyWhiteListDescription": "Ved å slette selskapets hviteliste, vil du ikke kunne gjenopprette den",
	"DeleteCompanyWhiteListTitle": "Slett selskapets hviteliste",
	"DomainRequired": "Domene må fylles ut",
	"FormInvalidValue": "Skjemaet inneholder ugyldige verdier",
	"ValidDomain": "Gyldig domenenavn bør starte med '@' (f.eks. @yahoo) eller gyldig e-postadresse (f.eks. Company@yahoo.com)",
	"ErrorDeletingDoctor": "Det oppstod en feil under sletting av prosessoren",
	"ErrorGettingDoctors": "Det oppstod en feil under henting av utøvere",
	"DoctorEmailAlreadyExist": "En bruker med samme e-postadresse er allerede opprettet i systemet. Prøv på nytt med en annen e-post.",
	"ErrorNewDoctor": "Det oppstod en feil under opprettelse av en ny utøver",
	"CouponCodeRequired": "Kupongkode må fylles ut",
	"UsernameRequired": "E-post må fylles ut",
	"FullNameRequired": "Navn må fylles ut",
	"ErrorUpdateProfileData": "Det oppstod en feil under lagring av profildata",
	"ErrorValidatingInsuranceMembership": "Det oppstod en feil under registreringen. Prøv på nytt eller kontakt oss hvis problemet vedvarer.",
	"InvalidPhoneNumber": "Ugyldig telefonnummer",
	"PhoneCallViewModel_ViewIsClosing": "Samtalen avsluttes når denne dialogboksen lukkes",
	"ErrorGettingPrices": "Det oppstod en feil under nedlasting av priser",
	"ErrorUpdatePrice": "Det oppstod en feil under oppdatering av pris",
	"Child": "låve",
	"ErrorCompanyConsultations": "Det oppstod en feil under henting av bedriftskonsultasjoner",
	"ErrorPatients": "Det oppstod en feil under henting av påmeldte pasienter",
	"ValidateCprInvalidCpr": "Vennligst oppgi et gyldig CPR-nummer. CPR-nummeret må være nøyaktig 10-sifret langt.",
	"Friday": "Fredag",
	"Monday": "Mandag",
	"Saturday": "Lørdag",
	"Sunday": "Søndag",
	"Thursday": "Torsdag",
	"Tuesday": "Tirsdag",
	"Wednesday": "Onsdag",
	"ErrorDeleteAccount": "Det oppstod en feil under sletting av konto",
	"ErrorCallQualityFeedback": "Kan ikke lagre tilbakemeldingen din",
	"PleaseEnterANumber": "Vennligst skriv inn et tall. Du har lov til å bruke desimaler (f.eks. 5,2 eller 5.2)",
	"PleaseEnterFullName": "Vennligst skriv inn ditt fulle navn",
	"CouldNotUpdateChild": "Kan ikke oppdatere barnet:",
	"CouldNotCreateChild": "Kan ikke opprette barn:",
	"ErrorDeleteChild": "Kunne ikke fjerne barn:",
	"UploadFailedTooLarge": "Filen \"{0}\" er for stor og kan derfor ikke lastes opp. Vennligst sjekk at filen din ikke er større enn 30 MB.",
	"Profile_AddChild": "Legg til barn",
	"Profile_EditChild": "Rediger barn",
	"Darn": "Øv!",
	"SorryForYourConcerns": "Vi beklager at det ikke gikk som forventet. Det vil være til stor hjelp for oss hvis du vil forklare hva som var galt.",
	"ThankYou": "Tak!",
	"ImproveOurselves": "Vi ønsker alltid å forbedre oss. Gi oss beskjed om hvordan.",
	"Great": "Dejligt!",
	"BigHelp": "Det vil være til stor hjelp hvis du vil sette ord på opplevelsen din.",
	"dateFnsShortDateFormat": "d. MMM yyyy",
	"dateFnsTimeFormat": "HH.mm",
	"dateFnsTodayRelativeFormat": "'I dag på' HH:mm",
	"dateFnsTomorrowRelativeFormat": "'I morgen kl' TT:mm",
	"ProfileConfirmEditKid": "Edelsten",
	"ClockValidatorError": "Klokken på apparatet ditt går galt. Vennligst sett den for å sikre at Hejdoktor fungerer.",
	"dateFnsLongDateFormat": "d. MMMM yyyy",
	"dateFnsLongDateTimeFormat": "d. MMMM yyyy 'på.' HH.mm",
	"dateFnsShortDateTimeFormat": "d. MMM yyyy HH.mm",
	"NameRequired": "Vennligst skriv inn ditt fulle navn",
	"TimeZoneWarning": "Klokkeslettene vises i din lokale tidssone: {timezone}",
	"Back": "Tilbake",
	"Next": "Neste",
	"PFAErrorNoAnswer": "Du må velge et svaralternativ før vi kan gå videre.",
	"SelectPlaceholder": "Velg",
	"QuestionXOfY": "Spørsmål {0} av {1}",
	"ErrorGettingCaregiverTips": "Det oppstod en feil under henting av tips",
	"ErrorNewCaregiverTip": "Det oppstod en feil under oppretting av et nytt tips",
	"Understood": "Jeg skjønner",
	"PleaseEnterPetName": "Vennligst skriv inn kjæledyrets navn",
	"PleaseSelectPetType": "Vennligst velg type kjæledyr",
	"PleaseSelectPetSex": "Vennligst velg kjønn",
	"PleaseChoosePetAge": "Velg kjæledyrets fødselsdato. Det trenger ikke å være 100 % nøyaktig.",
	"PleaseSelectMonth": "Vennligst velg din måned",
	"PleaseSelectYear": "Vennligst velg år",
	"CouldNotGetPets": "Kunne ikke plukke opp kjæledyr:",
	"CouldNotCreatePet": "Kunne ikke lage kjæledyr:",
	"CouldNotUpdatePet": "Kan ikke oppdatere kjæledyr:",
	"ErrorDeletePet": "Kunne ikke fjerne kjæledyr:",
	"Profile_AddPet": "Legg til kjæledyr",
	"Profile_EditPet": "Rediger kjæledyr",
	"MonthJanuary": "Januar",
	"MonthFebruary": "Februar",
	"MonthMay": "Maj",
	"MonthMarch": "Mars",
	"MonthApril": "April",
	"MonthJune": "Juni",
	"MonthJuly": "Juli",
	"MonthAugust": "August",
	"MonthSeptember": "September",
	"MonthOctober": "Oktober",
	"MonthNovember": "November",
	"MonthDecember": "Desember",
	"SelectMonth": "Velg måned",
	"SelectYear": "Velg år",
	"PetSexMale": "Han",
	"PetSexFemale": "Hun",
	"PetSexMaleNeutered": "Kastrert hann",
	"PetSexFemaleSterilized": "Sterilisert kvinne",
	"PetSexUnknown": "Ukjent",
	"PetTypeDog": "Hund",
	"PetTypeCat": "Kat",
	"PetTypeRabbit": "Kanin",
	"PetTypeRodent": "Gnaver",
	"SelectPetType": "Velg kjæledyrtype",
	"SelectPetSex": "Velg køn",
	"ErrorFetchingProfileData": "Det oppstod en feil! Prøv å laste inn siden på nytt.",
	"ErrorDateInTheFuture": "Du har oppgitt en fødselsdato som ligger i fremtiden. Vennligst skriv inn en gyldig fødselsdato og prøv igjen.",
	"ErrorTogglingNewsletter": "Kan ikke oppdatere nyhetsbrevpreferansene dine. Teamet vårt er på saken. Prøv igjen senere.",
	"MinorChildren": "Barn under 18 år",
	"ProfileConfirmAddKid": "Edelsten",
	"FullName": "Fullt navn",
	"CprNumber": "CPR-nummer",
	"CprPlaceholder": "ddmmåå-xxxx",
	"ConfirmCprIsCorrectHeader": "Er du sikker på at CPR-nummeret er riktig?",
	"CprModulusCheckWarning": "ikke ser ut som et gyldig CPR-nummer. For å kunne registrere og skrive ut resepter må vi ha riktig CPR-nummer. Kontroller derfor at CPR-nummeret er tastet inn riktig.",
	"ConfirmAndSave": "Bekreft og lagre",
	"Ok": "OK",
	"Error": "Det har oppstått en feil",
	"UnknownError": "Ukjent feil",
	"RefreshDataError": "Siden kunne ikke oppdateres. Vennligst last inn på nytt.",
	"FailedFetch": "Kunne ikke hente meldinger",
	"UploadFailed": "Opplasting mislyktes. Prøv igjen."
}